import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import ChartFrame from "../../ChartFrame";
import { normalizeOrganizationTicketChartData } from "./organizationTicketOutcomeChartData";

const OrganizationTicketsOutcomeChart = ({ title, chart, chartHeight }) => {
  const chartData = normalizeOrganizationTicketChartData(chart);

  return (
    <ChartFrame height={chartHeight} title={title}>
      <ResponsiveContainer>
        <ComposedChart
          data={chartData}
          margin={{
            top: 8,
            right: 12,
            left: -8,
            bottom: 18,
          }}
        >
          <CartesianGrid stroke="#ebebeb" vertical={false} />
          <XAxis
            dataKey="day"
            name="Day"
            axisLine={{ stroke: "var(--darkGrey)", strokeWidth: 1 }}
            tick={{ fontSize: 12 }}
          />
          <YAxis axisLine={{ stroke: "var(--darkGrey)", strokeWidth: 1 }} tick={{ fontSize: 12 }} />
          <Tooltip />
          <Legend width="100%" />
          <Bar dataKey="completed" name="Completed" stackId="ticket-outcome" fill="var(--green)" />
          <Bar dataKey="noShow" name="No Show" stackId="ticket-outcome" fill="var(--red)" />
          <Bar
            dataKey="unattended"
            name="Unattended"
            stackId="ticket-outcome"
            fill="var(--orange)"
          />
          <Line
            type="linear"
            strokeWidth={1.8}
            dataKey="total"
            name="Total Tickets"
            stroke="var(--blue)"
            dot={{ fill: "var(--blue)", r: 2 }}
            activeDot={{ r: 4 }}
            animationDuration={0}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </ChartFrame>
  );
};

export default OrganizationTicketsOutcomeChart;
